import { useRecoilState } from "recoil";
import { profilePrefillMetadataState } from "../Atoms/Profiles/state";
import "./InlineProfilesLinkingDropdown.scss";

const placeholder = "-Select-";

const InlineGroupProfilesLinkingDropdown = ({
  profiles,
  label,
  profilesGroups,
  getProfiles,
  type,
  staticProfiles,
  selectProfile,
  selected,
  groupLabel,
  groupIndex,
  findProfiles,
  resetDropDowns,
  prefill,
}) => {
  const [prefillMetadata, setPrefillMetadata] = useRecoilState(
    profilePrefillMetadataState
  );

  const updateMetadata = () => {
    const filtered = prefillMetadata.profiles.filter(
      (profile) => profile.type !== selected.type
    );
    filtered.push({ id: selected.id, type: selected.type });
    setPrefillMetadata((prev) => ({
      ...prev,
      profiles: filtered,
    }));
  };

  let resetGroup = document.getElementById("groupSelect");
  let resetFWs = document.getElementById("fwSelect");
  return (
    <div className="grid-row inline-profiles-linking-dd-container">
      <div className="grid-col-12 inline-profiles-linking-dd">
        <label className="inline-group-profiles-linking-text">
          {groupLabel}
        </label>
        <select
          className="usa-select group-select"
          id="groupSelect"
          title={label}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === "Unidentified") {
              //for cross browser - this code prevents other buttons triggers
              e.preventDefault();
            }
          }}
          onChange={(e) => {
            var select = document.getElementById("groupSelect");
            var selectText = select.options[select.selectedIndex].text;
            getProfiles(
              selectText,
              type,
              staticProfiles,
              profilesGroups,
              selectProfile
            );
            selectProfile(e.target.value, "select");
          }}
          value={groupIndex}
        >
          <option key={-1} value={placeholder}>
            {placeholder}
          </option>
          {profilesGroups &&
            profilesGroups.map((profile, index) => {
              return (
                <option key={index} value={index}>
                  {profile.name}
                </option>
              );
            })}
        </select>
        <span className="inline-group-profiles-linking-text">{label}</span>
        <select
          className="usa-select fw-select"
          id="fwSelect"
          title={label}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === "Unidentified") {
              //for cross browser - this code prevents other buttons triggers
              e.preventDefault();
            }
          }}
          onChange={(e) => {
            selectProfile(e.target.value, "select2");
          }}
        >
          <option key={-1} value={placeholder}>
            {placeholder}
          </option>
          {profiles &&
            profiles.map((profile, index) => {
              return (
                <option key={index} value={index}>
                  {profile.name}
                </option>
              );
            })}
        </select>
        <button
          type="button"
          className="usa-button inline-profiles-linking-btn"
          disabled={selected === placeholder ? true : false}
          onClick={() => {
            updateMetadata();
            prefill();
          }}
        >
          Populate
        </button>
        <button
          className="reset-button"
          onClick={(e) => {
            resetDropDowns(
              resetGroup,
              resetFWs,
              findProfiles,
              selectProfile,
              staticProfiles
            );
            e.preventDefault();
          }}
        >
          Reset
        </button>
      </div>
    </div>
  );
};

export default InlineGroupProfilesLinkingDropdown;
